import type { JSX } from "react";
import {
  BookOpen,
  Calendar,
  Folder,
  Home,
  KanbanSquare,
  KeyRound,
  Mail,
  MessageCircle,
  Settings,
  Users,
  LayoutGrid,
  type LucideIcon,
} from "lucide-react";

// Die Registry im Backend nennt nur einen Namen; welches Bild dazu gehört, weiß die
// Oberfläche. Unbekannte Namen bekommen ein neutrales Kachel-Symbol.
const icons: Record<string, LucideIcon> = {
  home: Home,
  users: Users,
  mail: Mail,
  calendar: Calendar,
  "message-circle": MessageCircle,
  folder: Folder,
  kanban: KanbanSquare,
  "book-open": BookOpen,
  "key-round": KeyRound,
  settings: Settings,
};

export function AppIcon({ name, className }: { name: string; className?: string }): JSX.Element {
  const Icon = icons[name] ?? LayoutGrid;
  return <Icon className={className} aria-hidden="true" />;
}
